export default {
  methods: {
    hoursFormatter(hours) {
      let string = "";
      hours < 0 ? (string += "-") : "";
      hours < 0 ? (hours *= -1) : "";
      let minutes = Number(hours * 60);

      let seconds = Number(hours * 3600);

      let mnts = (hours % 1).toFixed(2);
      mnts = mnts.substr(mnts.indexOf(".") + 1);
      let hrs = Math.floor((seconds % (3600 * 24)) / 3600);

      let days = Math.floor(seconds / (3600 * 24));

      let months = Math.floor(seconds / (3600 * 24 * 30));

      let years = Math.floor(seconds / (3600 * 24 * 30 * 12));

      years > 0 ? (string += `${years}y`) : "";
      years > 0 && months > 0 ? (string += `-`) : "";

      months > 0 ? (string += `${months}mo`) : "";
      months > 0 && days > 0 ? (string += `-`) : "";

      days > 0 ? (string += `${days}d`) : "";
      days > 0 && hrs > 0 ? (string += `-`) : "";

      hrs > 0 ? (string += `${hrs}h`) : "";
      hrs > 0 && mnts > 0 ? (string += `-`) : "";

      mnts > 0 ? (string += `${mnts}m`) : "";

      string === "" ? (string = "0h") : "";
      return string;
    }
  }
};
